import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { Navigate } from "react-router-dom";
import './ModernLoginPage.css';
// Import your logo - adjust the path based on your project structure
import RecruitmentXLogo from './rx_logo_white.svg'; // or .svg

const backend_url = process.env.REACT_APP_BACKEND_URL;
const env_type = process.env.REACT_APP_ENV_TYPE;
//const api_endpoint = '/v1/validate-credentials';
//const login_url = backend_url + api_endpoint;

const ModernLoginPage = ({ onLoginComplete, loggedIn }) => {
    console.log("Env:", env_type);
    // Login state
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [condition, setCondition] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
         // Password reset state
    const [showResetModal, setShowResetModal] = useState(false);
    const [resetStep, setResetStep] = useState(1); // 1: email, 2: code, 3: new password
    const [resetEmail, setResetEmail] = useState('');
    const [resetCode, setResetCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [resetMessage, setResetMessage] = useState('');
    const [resetError, setResetError] = useState('');
    const [isResetLoading, setIsResetLoading] = useState(false);

    useEffect(() => {
        document.body.style.backgroundColor = '#141414';
        document.body.style.margin = '0';
        document.body.style.padding = '0';
        document.body.style.minHeight = '100vh';
        return () => {
            document.body.style.backgroundColor = null;
            document.body.style.margin = null;
            document.body.style.padding = null;
            document.body.style.minHeight = null;
        };
    }, []);

    const displayMessage = (condition) => {
        console.log("condition: ", condition);
        if (condition === 'incorrect') {
            console.log('incorrect');
            return 'Incorrect email or password. Please try again.';
        } else if (condition === 'empty') {
            console.log('correct');
            return 'Email or password cannot be empty!';
        }
        return null;
    };

    const validateCredentials = async () => {
        console.log("Validate credentials func");
        let newCookieValue = "";

        if (email === "" || password === "") {
            console.log('Credentials are empty');
            setCondition('empty');
            return;
        }

        setIsLoading(true);
        try {
            const response = await axios({
                method: 'post',
                url: backend_url + '/v1/validate-credentials',
                data: {
                    Username: email,
                    Password: password
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            console.log("response.data: ", typeof(response.data.NewCookie));

            if (response.data.Valid) {
                console.log('Credentials are valid');
                const newCookieValue = response.data.NewCookie;
                console.log("################################################################");
                console.log('newCookieValue: ', newCookieValue);
                console.log("################################################################");
                onLoginComplete(newCookieValue);
            } else {
                console.log('Credentials are not valid');
                setCondition('incorrect');
            }
        } catch (error) {
            console.error('Error checking credentials validity', error);
            setCondition('incorrect');
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        validateCredentials();
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            validateCredentials();
        }
    };
    // Password reset functions
    const handleForgotPassword = () => {
        setShowResetModal(true);
        setResetStep(1);
        setResetEmail('');
        setResetCode('');
        setNewPassword('');
        setConfirmPassword('');
        setResetMessage('');
        setResetError('');
    };

    const handleRequestReset = async () => {
        if (!resetEmail) {
            setResetError('Please enter your email address');
            return;
        }

        setIsResetLoading(true);
        setResetError('');
        setResetMessage('');

        try {
            const response = await axios.post(
                backend_url + '/v1/request-password-reset',
                { email: resetEmail },
                { headers: { 'Content-Type': 'application/json' } }
            );

            if (response.data.success) {
                setResetMessage(response.data.message);
                setResetStep(2);
            } else {
                setResetError(response.data.error || 'Failed to send reset code');
            }
        } catch (error) {
            console.error('Error requesting password reset:', error);
            setResetError('Failed to send reset code. Please try again.');
        } finally {
            setIsResetLoading(false);
        }
    };

    const handleVerifyCode = async () => {
        if (!resetCode || resetCode.length !== 6) {
            setResetError('Please enter the 6-digit code');
            return;
        }

        setIsResetLoading(true);
        setResetError('');

        try {
            const response = await axios.post(
                backend_url + '/v1/verify-reset-code',
                {
                    email: resetEmail,
                    code: resetCode
                },
                { headers: { 'Content-Type': 'application/json' } }
            );

            if (response.data.success) {
                setResetStep(3);
                setResetMessage('');
            } else {
                setResetError(response.data.error || 'Invalid code');
            }
        } catch (error) {
            console.error('Error verifying code:', error);
            if (error.response && error.response.data) {
                setResetError(error.response.data.error || 'Invalid or expired code');
            } else {
                setResetError('Failed to verify code. Please try again.');
            }
        } finally {
            setIsResetLoading(false);
        }
    };

    const handleResetPassword = async () => {
        if (!newPassword || newPassword.length < 8) {
            setResetError('Password must be at least 8 characters');
            return;
        }

        if (newPassword !== confirmPassword) {
            setResetError('Passwords do not match');
            return;
        }

        setIsResetLoading(true);
        setResetError('');

        try {
            const response = await axios.post(
                backend_url + '/v1/reset-password',
                {
                    email: resetEmail,
                    code: resetCode,
                    newPassword: newPassword
                },
                { headers: { 'Content-Type': 'application/json' } }
            );

            if (response.data.success) {
                setResetMessage('Password reset successfully! You can now login with your new password.');
                setTimeout(() => {
                    setShowResetModal(false);
                    setEmail(resetEmail);
                }, 2000);
            } else {
                setResetError(response.data.error || 'Failed to reset password');
            }
        } catch (error) {
            console.error('Error resetting password:', error);
            if (error.response && error.response.data) {
                setResetError(error.response.data.error || 'Failed to reset password');
            } else {
                setResetError('Failed to reset password. Please try again.');
            }
        } finally {
            setIsResetLoading(false);
        }
    };

    const closeResetModal = () => {
        setShowResetModal(false);
        setResetStep(1);
        setResetEmail('');
        setResetCode('');
        setNewPassword('');
        setConfirmPassword('');
        setResetMessage('');
        setResetError('');
    };

    if (loggedIn === true) {
        console.log("Already logged in: redirecting to main page");
        return <Navigate to="/" />;
    }

    return (
        <div className="modern-login-container">
            <div className="modern-login-card">
                {/* Logo */}
                <div className="modern-logo-container">
                    <img
                        src={RecruitmentXLogo}
                        alt="RecruitmentX"
                        className="modern-logo-image"
                    />
                </div>

                <h2 className="modern-login-title">Welcome back</h2>
                <p className="modern-login-subtitle">Log in to your account to continue</p>

                <form onSubmit={handleSubmit} className="modern-login-form">
                    <div className="modern-input-group">
                        <label htmlFor="email" className="modern-label">Email</label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onKeyPress={handleKeyPress}
                            placeholder="Enter your email"
                            className="modern-input-field"
                        />
                    </div>

                    <div className="modern-input-group">
                        <label htmlFor="password" className="modern-label">Password</label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyPress={handleKeyPress}
                            placeholder="Enter your password"
                            className="modern-input-field"
                        />
                    </div>

                    {condition && (
                        <div className="modern-error-message">
                            {displayMessage(condition)}
                        </div>
                    )}

                    <button
                        type="submit"
                        className="modern-submit-button"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Logging in...' : 'Login'}
                    </button>
                </form>
                <div className="modern-footer-links">
                    <button
                        onClick={handleForgotPassword}
                        className="modern-forgot-password-link"
                    >
                        Forgot Password?
                    </button>
                </div>

                <div className="modern-footer-text">
                    Don't have an account? <a href="/signup" className="modern-signup-link">Sign up</a>
                </div>
            </div>
            {/* Password Reset Modal */}
            {showResetModal && (
                <div className="modern-modal-overlay" onClick={closeResetModal}>
                    <div className="modern-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="modern-modal-close" onClick={closeResetModal}>×</button>

                        <h3 className="modern-modal-title">Reset Password</h3>

                        {/* Step 1: Enter Email */}
                        {resetStep === 1 && (
                            <div className="modern-modal-body">
                                <p className="modern-modal-description">
                                    Enter your email address and we'll send you a code to reset your password.
                                </p>
                                <div className="modern-input-group">
                                    <label htmlFor="reset-email" className="modern-label">Email</label>
                                    <input
                                        id="reset-email"
                                        type="email"
                                        value={resetEmail}
                                        onChange={(e) => setResetEmail(e.target.value)}
                                        placeholder="Enter your email"
                                        className="modern-input-field"
                                        disabled={isResetLoading}
                                    />
                                </div>

                                {resetMessage && (
                                    <div className="modern-success-message">
                                        {resetMessage}
                                    </div>
                                )}

                                {resetError && (
                                    <div className="modern-error-message">
                                        {resetError}
                                    </div>
                                )}

                                <button
                                    onClick={handleRequestReset}
                                    className="modern-submit-button"
                                    disabled={isResetLoading}
                                >
                                    {isResetLoading ? 'Sending...' : 'Send Reset Code'}
                                </button>
                            </div>
                        )}

                        {/* Step 2: Enter Code */}
                        {resetStep === 2 && (
                            <div className="modern-modal-body">
                                <p className="modern-modal-description">
                                    Enter the 6-digit code sent to {resetEmail}
                                </p>
                                <div className="modern-input-group">
                                    <label htmlFor="reset-code" className="modern-label">Reset Code</label>
                                    <input
                                        id="reset-code"
                                        type="text"
                                        value={resetCode}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, '');
                                            if (value.length <= 6) {
                                                setResetCode(value);
                                            }
                                        }}
                                        placeholder="Enter 6-digit code"
                                        className="modern-input-field modern-code-input"
                                        maxLength="6"
                                        disabled={isResetLoading}
                                    />
                                </div>

                                {resetError && (
                                    <div className="modern-error-message">
                                        {resetError}
                                    </div>
                                )}

                                <div className="modern-modal-actions">
                                    <button
                                        onClick={() => setResetStep(1)}
                                        className="modern-secondary-button"
                                        disabled={isResetLoading}
                                    >
                                        Back
                                    </button>
                                    <button
                                        onClick={handleVerifyCode}
                                        className="modern-submit-button"
                                        disabled={isResetLoading || resetCode.length !== 6}
                                    >
                                        {isResetLoading ? 'Verifying...' : 'Verify Code'}
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Step 3: Set New Password */}
                        {resetStep === 3 && (
                            <div className="modern-modal-body">
                                <p className="modern-modal-description">
                                    Create a new password for your account
                                </p>
                                <div className="modern-input-group">
                                    <label htmlFor="new-password" className="modern-label">New Password</label>
                                    <input
                                        id="new-password"
                                        type="password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        placeholder="Enter new password (min 8 characters)"
                                        className="modern-input-field"
                                        disabled={isResetLoading}
                                    />
                                </div>

                                <div className="modern-input-group">
                                    <label htmlFor="confirm-password" className="modern-label">Confirm Password</label>
                                    <input
                                        id="confirm-password"
                                        type="password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        placeholder="Confirm new password"
                                        className="modern-input-field"
                                        disabled={isResetLoading}
                                    />
                                </div>

                                {resetMessage && (
                                    <div className="modern-success-message">
                                        {resetMessage}
                                    </div>
                                )}

                                {resetError && (
                                    <div className="modern-error-message">
                                        {resetError}
                                    </div>
                                )}

                                <button
                                    onClick={handleResetPassword}
                                    className="modern-submit-button"
                                    disabled={isResetLoading}
                                >
                                    {isResetLoading ? 'Resetting...' : 'Reset Password'}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ModernLoginPage;